import { stateVariables } from './variables';
import { wrapperReducers } from './reducers';
import { wrapperFunctions } from './functions';
import { wrapperCreator } from '../../wrappers/wrapperCreator';
import logic from './logic';
import { wrapperIdentifier } from './common';
import { SessionWrapper } from '../../wrappers/SessionWrapper';
import { BackendWrapper } from '../../wrappers/BackendWrapper';
import { virtualsGenerator } from './virtuals';

export const TestsWrapper = wrapperCreator(
  wrapperIdentifier,
  stateVariables,
  wrapperFunctions,
  wrapperReducers,
  logic,
  undefined,
  [SessionWrapper, BackendWrapper],
  virtualsGenerator
);
